import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { useApp } from '../store';
export function NewsPage() {
  const {
    articles
  } = useApp();
  const [active, setActive] = useState('All');
  const categories = ['All', ...Array.from(new Set(articles.map(a => a.category)))];
  const filtered = active === 'All' ? articles : articles.filter(a => a.category === active);
  const [hero, ...rest] = filtered;
  return <>
      <PageHeader title="News" subtitle="Company updates, announcements, and stories." data-id="element-522" data-mp="1erlp7m7b5at5" />

      {/* Category filter */}
      <div className="flex flex-wrap gap-2 mb-6" data-id="element-523" data-mp="1jp421nog4a6f">
        {categories.map(c => <button key={c} onClick={() => setActive(c)} className={`px-3.5 py-1.5 rounded-full text-sm font-semibold transition-colors ${active === c ? 'bg-navy-600 text-white' : 'bg-white text-navy-600 border border-navy-100 hover:border-gold-400'}`} data-id="element-524" data-mp="3gjqpbkyyneey">
            {c}
          </button>)}
      </div>

      {hero && <Link to={`/news/${hero.id}`} className="block group mb-8" data-id="element-525" data-mp="2m8jgpzkyd142">
          <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} className="grid md:grid-cols-2 gap-6 bg-white rounded-2xl border border-navy-100 overflow-hidden" data-id="element-526" data-mp="2m6q84eqs46tf">
            <div className="h-56 md:h-auto overflow-hidden" data-id="element-527" data-mp="34zapayx48nhe">
              <img src={hero.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-528" data-mp="34xpur9asx4jj" />
            </div>
            <div className="p-6 flex flex-col justify-center" data-id="element-529" data-mp="1ti17egtmy3i7">
              <div className="flex items-center gap-2 mb-2" data-id="element-530" data-mp="1phr1f45ufd3c">
                <span className="text-xs font-bold uppercase tracking-widest text-gold-600" data-id="element-531" data-mp="1qzz6kov3j80v">
                  {hero.category}
                </span>
                {hero.needsReview && <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[0.65rem] font-bold uppercase tracking-wide bg-gold-50 text-gold-700 border border-gold-200" data-id="element-532" data-mp="1h1jofbe1r93i">
                    <AlertTriangle className="w-3 h-3" data-id="element-533" data-mp="1m2frjmqkqr7v" /> Needs Review
                  </span>}
              </div>
              <h2 className="text-2xl font-serif font-bold text-navy-900 leading-tight mb-2 group-hover:text-gold-600 transition-colors" data-id="element-534" data-mp="1d0gbawndvr5z">
                {hero.title}
              </h2>
              <p className="text-navy-600 text-sm leading-relaxed mb-4" data-id="element-535" data-mp="139vener9swpp">
                {hero.excerpt}
              </p>
              <div className="flex items-center gap-2 text-xs text-navy-400" data-id="element-536" data-mp="pa3uewa5uk39">
                <img src={hero.authorAvatar} alt="" className="w-6 h-6 rounded-full" data-id="element-537" data-mp="tbpbyuxn3mjs" />
                <span className="font-medium text-navy-700" data-id="element-538" data-mp="anx1ajwac1ii">{hero.author}</span>
                <span data-id="element-539" data-mp="5pvh1vn4hw5g">·</span>
                <span data-id="element-540" data-mp="5qn42i2nmlk4">{hero.date}</span>
                <span className="inline-flex items-center gap-1 ml-auto" data-id="element-541" data-mp="jouvkagx8unw">
                  <Clock className="w-3 h-3" data-id="element-542" data-mp="ep8hjyt9rae1" />
                  {hero.readTime}
                </span>
              </div>
            </div>
          </motion.div>
        </Link>}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-543" data-mp="tkemeigmp35s">
        {rest.map((a, i) => <motion.div key={a.id} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} data-id="element-544" data-mp="olljfjyywujv" data-mpi={i}>
            <Link to={`/news/${a.id}`} className="block group bg-white rounded-xl border border-navy-100 overflow-hidden h-full hover:shadow-md transition-shadow" data-id="element-545" data-mp="17fh4s52nwkzh">
              <div className="h-40 overflow-hidden" data-id="element-546" data-mp="1vfsuyfwh64v2">
                <img src={a.image} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-547" data-mp="207u4vv667jhx" />
              </div>
              <div className="p-4" data-id="element-548" data-mp="18ihg37c0cu6z">
                <div className="flex items-center gap-2 mb-1" data-id="element-549" data-mp="18jivtp3yy4v1">
                  <span className="text-[0.7rem] font-bold uppercase tracking-wide text-gold-600" data-id="element-550" data-mp="1cjjb1byw6k35">
                    {a.category}
                  </span>
                  {a.needsReview && <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[0.6rem] font-bold uppercase tracking-wide bg-gold-50 text-gold-700 border border-gold-200" data-id="element-551" data-mp="1mhqlrd2l85wp">
                      <AlertTriangle className="w-3 h-3" data-id="element-552" data-mp="2xv1ic8w3wgwa" /> Stale
                    </span>}
                </div>
                <h3 className="text-base font-serif font-bold text-navy-900 leading-snug mb-2 group-hover:text-gold-600 transition-colors" data-id="element-553" data-mp="m7zf4zg1h025">
                  {a.title}
                </h3>
                <div className="flex items-center gap-1.5 text-xs text-navy-400" data-id="element-554" data-mp="chcyr30i05ie">
                  <span data-id="element-555" data-mp="7j354wuf9cyw">{a.date}</span>
                  <span data-id="element-556" data-mp="7i0fes8u5gkk">·</span>
                  <span data-id="element-557" data-mp="3isrcy0e1i9h">{a.readTime}</span>
                </div>
              </div>
            </Link>
          </motion.div>)}
      </div>
    </>;
}